import React from 'react';

export default function Announcement() {
  return (
    <section className="bg-indigo-600">
      <div className="max-w-screen-xl mx-auto px-6 py-3">
        <a href="/">
          <p className="text-white text-center text-lg emoji-icon"><span role="img" aria-label="stopwatch">⏱️</span>&nbsp;&nbsp;Our current NIF turnaround time is 1 week&nbsp;&nbsp;<span role="img" aria-label="stopwatch">⏱️</span></p>
        </a>
      </div>  
    </section>
  )
}
